import { reduxForm } from 'redux-form';
import Component from './FormCreateUpdateReason.js';


export default reduxForm({
  form: 'formCreateUpdateReason',
  initialValues: {
    reason: '',
    isRequestUnblock: false,
    isActive: false,
    supportDocument: [],
    isAttachFile: false
  },
  validate: (values) => {
    const errors = {};

    if (!values.reason || values.reason.trim() === '') {
      errors.reason = 'Wajib diisi';
    }

    if (typeof values.isRequestUnblock !== 'boolean') {
      errors.isRequestUnblock = 'Wajib dipilih';
    }

    return errors;
  },
})(Component);
